import PropTypes from 'prop-types';
import React, {Component} from 'react';

export default class SidebarItemSingle extends Component {
  render() {
    const {children} = this.props;
    return children ? (
      <div className="sidebar__item--single">{children}</div>
    ) : null;
  }
}

SidebarItemSingle.propTypes = {
  children: PropTypes.any,
};
